// extracted by mini-css-extract-plugin
module.exports = {"ecSkeletonBox":"src-components-layout-SkeletonBox-__styles-module___ecSkeletonBox","shimmer":"src-components-layout-SkeletonBox-__styles-module___shimmer"};